import infoStyles from "../../styles/estilos/infoMetodos.module.css";
import depositoInfoImage from "../../images/info_deposito_bancario.png";

function DepositoInfo() {
  return (
    <div className={infoStyles.infoContainer}>
      <div className={infoStyles.title}>DEPOSITO BANCARIO</div>
      <img
        src={depositoInfoImage}
        alt="Información de depósito bancario"
        className={infoStyles.transferInfoImage}
      />
    </div>
  );
}

export default DepositoInfo;
